var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{key:_vm.key,class:{animation: _vm.ani},attrs:{"src":"/assets/img/logo/Logo.svg","title":_vm.$t('company.name')},on:{"mouseenter":_vm.setHover}})
}
var staticRenderFns = []

export { render, staticRenderFns }